<ng-container *ngIf="step === 'insertion-list'">
  <rt-redactor-inserts-dropdown-item
    [iconName]="'rti-kununu'"
    [heading]="'app.redactor_inserts.integrations_kununu.dropdown.heading' | translate"
    [subheading]="'app.redactor_inserts.integrations_kununu.dropdown.subheading' | translate"
    [link]="canManageIntegrations ? 'settings/integrations' : undefined"
    [linkNavigationExtras]="{ queryParams: { open_integration: 'kununu' } }"
    [selected]="selected"
    (stepInside)="stepInside.emit()"
  >
  </rt-redactor-inserts-dropdown-item>
</ng-container>

<ng-container *ngIf="step === 'integrations-kununu'">
  <div layout-vertical>
    <rt-redactor-inserts-dropdown-header
      [hasBackAction]="hasBackAction"
      [label]="'app.redactor_inserts.integrations_kununu.dropdown.heading' | translate"
      (goBack)="back.emit()"
      (closeDropdown)="closeDropdown.emit()"
    >
    </rt-redactor-inserts-dropdown-header>

    <rt-dropdown-item (click)="insertApplicantFeedback()">
      {{ 'app.redactor_inserts.integrations_kununu.dropdown.applicant_feedback' | translate }}
    </rt-dropdown-item>

    <rt-dropdown-item (click)="insertEmployeeFeedback()">
      {{ 'app.redactor_inserts.integrations_kununu.dropdown.employee_feedback' | translate }}
    </rt-dropdown-item>
  </div>
</ng-container>
